import { CARE_HOSTS, CLINICAL_HOSTS, type HostAppId } from './hosts';

function normalizeHost(hostname: string): string {
  return hostname.trim().toLowerCase().replace(/\.$/, '');
}

function hostMatches(hostname: string, needles: readonly string[]): boolean {
  const h = normalizeHost(hostname);
  return needles.some((n) => h === n || h.endsWith(`.${n}`) || h.includes(n));
}

/**
 * Resuelve qué aplicación debe servir el hostname actual.
 * Misma infra Supabase/auth; layouts y módulos separados por app.
 */
export function resolveHostApp(hostname?: string): HostAppId {
  const h =
    hostname ??
    (typeof window !== 'undefined' ? window.location.hostname : '');

  if (h.includes('care.concienciasanate.com') || hostMatches(h, CARE_HOSTS) || /^care\./i.test(h)) {
    return 'care';
  }

  if (
    h === 'concienciasanate.com' ||
    h === 'www.concienciasanate.com' ||
    h.includes('clinical.concienciasanate.com') ||
    h.includes('app.concienciasanate.com') ||
    hostMatches(h, CLINICAL_HOSTS) ||
    /^clinical\./i.test(h) ||
    /^app\./i.test(h)
  ) {
    return 'clinical';
  }

  const devDefault = String(import.meta.env.VITE_DEFAULT_HOST_APP ?? '').toLowerCase();
  if (import.meta.env.DEV && (devDefault === 'care' || devDefault === 'clinical')) {
    return devDefault as HostAppId;
  }

  return 'clinical';
}

export function isCareHost(hostname?: string): boolean {
  return resolveHostApp(hostname) === 'care';
}

export function isClinicalHost(hostname?: string): boolean {
  return resolveHostApp(hostname) === 'clinical';
}
